'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _watermark = require('./watermark');

var _watermark2 = _interopRequireDefault(_watermark);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _watermark2.default; /**
                                       * Tencent is pleased to support the open source community by making SPA UI available.
                                       * Copyright (C) 2019, a Tencent company. All rights reserved.
                                       */

/**
 * @fileoverview 导出组件
 * @author kirkzheng
 */